(function () {
  var query = '(hover: hover) and (min-width: 990px)';

  function mount() {
    if (!window.matchMedia(query).matches) return;
    document.querySelectorAll('template.card-hover-template').forEach(function (template) {
      if (template.dataset.mounted === 'true' || !template.content || !template.parentNode) return;
      template.dataset.mounted = 'true';
      template.parentNode.appendChild(template.content.cloneNode(true));
      template.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }

  var media = window.matchMedia(query);
  if (typeof media.addEventListener === 'function') {
    media.addEventListener('change', mount);
  }
})();
